import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@devowl-wp/react-folder-tree";
import { __, _i } from "../../utils/i18n.js";
const shortcutInfo = _i(__('This is a shortcut of a media library file. Shortcuts doesn\'t need any physical storage {{strong}}(0 kB){{/strong}}. If you want to change the file itself, you must do this in the original file (for example replace media file through a plugin).\nNote also that the fields in the shortcuts can be different to the original file, for example "Title", "Description" or "Caption".'), {
    strong: /*#__PURE__*/ _jsx("strong", {})
});
function ShortcutIconTooltip() {
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: "top",
        title: __("Shortcut"),
        content: shortcutInfo,
        children: /*#__PURE__*/ _jsx("i", {
            className: "rmlicon-share"
        })
    });
}
export { ShortcutIconTooltip };
